export const login = '/';
export const dashboard = '/dashboard';
export const convert = '/convert/:id';
